import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements
} from 'react-router-dom';

import ChartsPage from 'pages/ChartsPage';
import HomePage from 'pages/HomePage';
import LoginPage from 'pages/LoginPage';
import ResetPasswordPage from 'pages/ResetPasswordPage';
import StudentRepositoryPage from 'pages/StudentRepositoryPage';

import AnonimousGuard from 'components/AnonimousGuard';
import AuthGuard from 'components/AuthGuard';
import MainLayout from 'components/Layout/MainLayout';

import { URLS } from 'config/urls';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Public / semi-public routes */}
      <Route path={URLS.RESET_PASSWORD} element={<ResetPasswordPage />} />

      <Route element={<AnonimousGuard />}>
        <Route path={URLS.LOGIN} element={<LoginPage />} />
      </Route>
      <Route path="/" element={<MainLayout />}>
        <Route path={URLS.HOME} element={<HomePage />} />
        <Route path="/" element={<HomePage />} />

        {/* Protected routes */}
        <Route element={<AuthGuard />}>
          <Route path={URLS.ABOUT} element={<StudentRepositoryPage />} />
          <Route path={URLS.CHARTS} element={<ChartsPage />} />
        </Route>
      </Route>
    </>
  )
);

const Routes = () => <RouterProvider router={router} />;
export default Routes;
